import { render, staticRenderFns } from "./FaceBinding.vue?vue&type=template&id=22122330&scoped=true"
import script from "./FaceBinding.vue?vue&type=script&lang=js"
export * from "./FaceBinding.vue?vue&type=script&lang=js"
import style0 from "./FaceBinding.vue?vue&type=style&index=0&id=22122330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22122330",
  null
  
)

export default component.exports